module.exports = __webpack_public_path__ + "static/media/5.18bb0962.svg";